import HeadlineWrapper from './HeadlineWrapper'
import ArticleHeader from '@components/HeadlineLead/ArticleHeader'

const exports = {
  ArticleHeader,
  HeadlineWrapper,
}

export default exports
